import { render, staticRenderFns } from "./ProductShoppingcartButton.vue?vue&type=template&id=3ec1ad2f"
import script from "./ProductShoppingcartButton.vue?vue&type=script&lang=js"
export * from "./ProductShoppingcartButton.vue?vue&type=script&lang=js"
import style0 from "./ProductShoppingcartButton.vue?vue&type=style&index=0&id=3ec1ad2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports